import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import _ from 'lodash';
import CustomLoader from '../../common/Loader';
import * as Icon from 'react-feather';
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../config';
import { logActivity } from '../../../services/utilService';
import Select from "react-select";
import { getDataSources } from '../../../services/dataSourceService';
import { ResultSource } from '../../../constants/ResultSource';
import { findParameters, getResultSourceTypes, getSPV } from '../../../services/formService';
import { updateReportConfig } from '../../../services/reportService';

class ListDataSource extends Component {
    DataSources = [];
    ResultSources = [];
    StoredProcedures = [];
    Views = [];

    constructor(props) {
        super(props);

        this.state = {
            compID: this.props.compID,
            preloadData: this.props.preloadData ? this.props.preloadData : undefined,
            Project_ID: this.props.Project_ID,
            Report_ID: this.props.Report_ID,
            DataSource_ID: 0,
            ResultSource_ID: 0,
            ResultSource_Content: "",
            open_options: "",
            Parameters: [],
            toggleRender: false,
            saveSource: this.props.saveSource ? this.props.saveSource : '/api/v2/reports/updateReportConfig',
            loading: true,
        };

        this.handleSave = this.handleSave.bind(this);
        this.clearFields = this.clearFields.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSPVChange = this.handleSPVChange.bind(this);
    }

    async componentDidMount() {
        const { data: DS } = await getDataSources();
        this.DataSources = DS;
        const { data: resultSources } = await getResultSourceTypes();
        this.ResultSources = JSON.parse(resultSources.resultSources);
        this.DataSources.length > 0 && this.setState({ loading: false });
    }

    getConn() {
        const source = this.DataSources.find((source) => {
            return source.DataSource_ID === this.state.DataSource_ID;
        });
        return source.Connection_String;
    };

    getOptions = async (value) => {
        const { data } = await getSPV(value, this.getConn());
        if (value === ResultSource.SP) {
            this.StoredProcedures = data;
        } else if (value === ResultSource.View) {
            this.Views = data;
        }
    };

    handleChange = (input) => {
        let value = input.value;
        if (input.name.includes("ID")) {
            value = parseInt(value);
        }
        this.setState({ [input.name]: value });
    };

    handleResultSourceChange = async (input) => {
        const name = input.name.split(":").pop();
        let value = parseInt(input.value);
        this.setState({ [name]: value });
        this.getOptions(value);
    };

    handleSPVChange = async (e, value) => {
        this.setState({ ResultSource_Content: value });
        if (this.state.ResultSource_ID === ResultSource.SP) {
            const { data } = await findParameters(value, this.getConn());
            if (typeof data === "object") {
                const Parameters = data.map((par) => {
                    par.Parameter_ID = 0;
                    par.Default_Value = "";
                    if ((par.Name).toLowerCase().includes('institution')) {
                        let institutionElId = localStorage.getItem('Inst_ID'); par.Default_Value = institutionElId;
                    }
                    return par;
                });
                this.setState({ Parameters });
            }
        }
    };

    handldParChange = (text, index) => {
        const Parameters = [...this.state.Parameters];
        Parameters[index]["Default_Value"] = text;
        this.setState({ Parameters });
    };

    clearFields() {
        this.setState({
            DataSource_ID: 0,
            ResultSource_ID: 0,
            ResultSource_Content: "",
            open_options: "",
            Parameters: []
        });
    }

    async handleSave() {
        //Form Validation
        let updatedReportObj = {}, stateObj = this.state;
        if (this.state.compID == 'reportBuilder') {
            updatedReportObj = {
                Report_ID: stateObj.Report_ID,
                Builder_DataSource_ID: stateObj.DataSource_ID,
                Builder_ResultSource_ID: 4,
                Builder_ResultSource_Content: stateObj.ResultSource_Content,
                Builder_Params: stateObj.Parameters
            }
        }
        else if (this.state.compID == 'reportViewer') {
            updatedReportObj = {
                Report_ID: stateObj.Report_ID,
                Viewer_DataSource_ID: stateObj.DataSource_ID,
                Viewer_ResultSource_ID: 4,
                Viewer_ResultSource_Content: stateObj.ResultSource_Content,
                Viewer_Params: stateObj.Parameters
            }
        }
        try {
            let { data } = await updateReportConfig(updatedReportObj);
            if (typeof data.data === 'string') {
                throw new Error('error');
            }
            else {
                toaster('success', 'Report Confguration updated.');
                console.log('data', data);
            }
        }
        catch (e) {
            toaster('error', 'Oops! Cannot update confgurations at this time. Please try again later.');
        }
    }

    render() {
        const loading = (<CustomLoader loading={this.state.loading} />);
        const { compID, DataSource_ID, ResultSource_ID, ResultSource_Content, open_options, Parameters, toggleRender } = this.state;
        try {
            if (this.state.loading) { return loading; }
            else {
                return (
                    <React.Fragment key={toggleRender}>
                        <div className='ml-3 mt-n2'>
                            <div className="form-group">
                                <label htmlFor={"DataSource" + compID}>Select Data Source</label>
                                <select name="DataSource_ID" id={"DataSource" + compID} className="form-control" value={DataSource_ID} onChange={(e) => this.handleChange(e.target)}>
                                    <option value="0">- Select -</option>
                                    {this.DataSources.map((source) => {
                                        return (
                                            <option key={source.DataSource_ID} value={source.DataSource_ID}>
                                                {source.Description}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                            <React.Fragment>
                                <div className="form-group">
                                    {this.ResultSources.map((source, sourceIndex) => {
                                        return (
                                            <div className="form-check form-check-inline" key={compID + source.ResultSource_Type_Name}>
                                                <input
                                                    type="radio"
                                                    className="form-check-input"
                                                    id={compID + source.ResultSource_Type_Name}
                                                    name={compID + ":ResultSource_ID"}
                                                    value={source.ResultSource_ID}
                                                    checked={source.ResultSource_ID === ResultSource_ID}
                                                    onChange={(e) => this.handleResultSourceChange(e.target)}
                                                    onClick={(e) => this.handleResultSourceChange(e.target)}
                                                />
                                                <label
                                                    htmlFor={compID + source.ResultSource_Type_Name}
                                                    className="form-check-label"
                                                >
                                                    {source.ResultSource_Type_Name}
                                                </label>
                                            </div>
                                        );
                                    })}

                                    {ResultSource_ID === ResultSource.Query && (
                                        <div>
                                            <TextField
                                                id={compID + "resultSourceContent"}
                                                label="Enter Query"
                                                variant="outlined"
                                                fullWidth
                                                margin="dense"
                                                name="ResultSource_Content"
                                                value={ResultSource_Content}
                                                onChange={(e) => this.handleChange(e.target)}
                                            />
                                        </div>
                                    )}

                                    {(ResultSource_ID === ResultSource.SP ||
                                        ResultSource_ID === ResultSource.View) && (
                                            <div>
                                                <Autocomplete
                                                    id={compID + "resultSourceContent"}
                                                    options={
                                                        open_options
                                                            ? ResultSource_ID === ResultSource.SP
                                                                ? this.StoredProcedures
                                                                : this.Views
                                                            : []
                                                    }
                                                    getOptionLabel={(option) => option}
                                                    fullWidth
                                                    size="small"
                                                    value={ResultSource_Content}
                                                    name="ResultSource_Content"
                                                    onChange={this.handleSPVChange}
                                                    inputValue={open_options}
                                                    onInputChange={(e, val) => {
                                                        this.setState({ open_options: val });
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label={
                                                                ResultSource_ID === ResultSource.SP
                                                                    ? "Stored Procedure Name"
                                                                    : "View Name"
                                                            }
                                                        />
                                                    )}
                                                />
                                            </div>
                                        )}

                                    {ResultSource_ID === ResultSource.SP &&
                                        Parameters.length > 0 &&
                                        Parameters.map((par, idx) => {
                                            return (
                                                <TextField
                                                    id={compID + "." + par.Name}
                                                    key={compID + "." + par.Name}
                                                    label={par.Name + "(" + par.Type + ")"}
                                                    placeholder="Default Value"
                                                    fullWidth
                                                    value={par.Default_Value}
                                                    onChange={(e) =>
                                                        this.handldParChange(e.target.value, idx)
                                                    }
                                                />
                                            );
                                        })}
                                </div>
                            </React.Fragment>
                            <div class='row'>
                                <button className='btn btn-primary ml-2' onClick={this.handleSave}>Save</button>
                                <button className='btn btn-success ml-2' onClick={this.clearFields}>Reset</button>
                            </div>
                        </div>
                        <br />
                        <ToastContainer />
                    </React.Fragment >
                );
            }
        }
        catch (e) {
            console.error('Error loading Add Variable Component: ', e);
            return (loading);
        }
    }
}

export default ListDataSource;